import { FeatureFlag } from '@ps/web-core-enums';

import useFeature from '@swf/core/hooks/useFeature';
import { EventTypeId } from '@swf/sports/types/eventType';

const useIsEventTypeLiveDataEnabled = (eventTypeId: EventTypeId) => {
  const isLiveDataEnabled = useFeature(FeatureFlag.ISPEnableLiveData);
  const isLiveAmericanFootballDataEnabled = useFeature(
    FeatureFlag.ISPEnableLiveAmericanFootballData
  );
  const isLiveFootballDataEnabled = useFeature(FeatureFlag.ISPEnableLiveFootballData);
  const isLiveTennisDataEnabled = useFeature(FeatureFlag.ISPEnableLiveTennisData);

  if (!isLiveDataEnabled) return false;

  switch (eventTypeId) {
    case EventTypeId.AMERICAN_FOOTBALL:
      return isLiveAmericanFootballDataEnabled;
    case EventTypeId.SOCCER:
      return isLiveFootballDataEnabled;
    case EventTypeId.TENNIS:
      return isLiveTennisDataEnabled;
    default:
      return false;
  }
};

export default useIsEventTypeLiveDataEnabled;
